import script from "./ArgonButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonButton.vue?vue&type=script&setup=true&lang=js"

import "./ArgonButton.vue?vue&type=style&index=0&id=236d9433&scoped=true&lang=css"
import "./ArgonButton.vue?vue&type=style&index=1&id=236d9433&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236d9433"]])

export default __exports__